import Information from '@/views/Settings/Information'

export default {
  Information,
}
